import { useTranslation } from 'react-i18next';
import { Button, Stack } from '@hotjar/hotsauce';
import { GuideCard } from '@hotjar/activation-toolkit';
import { useGuideCardVisibility } from '@hotjar/webapp/hooks/useGuideCardVisibility';
import HighlightsBanner from './assets/highlights-guide.jpg';
import { useGuideCardTrack } from './useGuideCardTrack';
import { BannerImage } from './components/BannerImage';

export function HighlightsGuide(): React.ReactElement | null {
  const { t } = useTranslation();
  const { click: trackClick } = useGuideCardTrack();
  const { isGuideCardVisible, dismissGuideCard } = useGuideCardVisibility('highlights-guide');

  const handleCTAClick = () => {
    dismissGuideCard();
    trackClick('go to course');
  };

  const handleDismissGuideCard = () => {
    dismissGuideCard();
    trackClick('dismiss guide card');
  };

  if (!isGuideCardVisible) return null;

  return (
    <GuideCard
      label={t('activation:guides.highlights.label')}
      title={t('activation:guides.highlights.title')}
      onDismiss={handleDismissGuideCard}
      description={t('activation:guides.highlights.description')}
      media={<BannerImage src={HighlightsBanner} />}
      actions={
        <Stack direction="row">
          <Button
            isExternal
            as="a"
            kind="secondary"
            icon="open_new_window"
            onClick={handleCTAClick}
            href="https://learning.hotjar.com/courses/collaborating-with-your-team-using-highlights/view/"
          >
            {t('activation:guides.highlights.cta')}
          </Button>
        </Stack>
      }
    />
  );
}
